import CityPageTemplate from "../city-template/CityPageTemplate";
import { rivertonConfig } from "./data";

export default function RivertonPage() {
  return <CityPageTemplate config={rivertonConfig} />;
}